import { render, staticRenderFns } from "./IconBug.vue?vue&type=template&id=78a6a725&scoped=true"
var script = {}
import style0 from "./IconBug.vue?vue&type=style&index=0&id=78a6a725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6a725",
  null
  
)

export default component.exports